import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApiConfig } from "@shared/models/redux";
import { openNotificationThunk } from "@store/Notification/thunks";
import { closeResetMFADialog } from "@myProfile/store/ducks";

export const enrollMFAThunk = createAsyncThunk<boolean, string | undefined, ThunkApiConfig>(
  "myprofile/enrollMFAThunk",
  async (email, { rejectWithValue, dispatch, extra }) => {
    try {
      const response = await extra<any>("entitlements/v1/user/UserProfile/enrollMFA", {
        method: "post",
      });

      const responseData = response.data;
      const isSuccess = typeof responseData === "boolean" ? responseData : responseData?.success !== false;

      if (isSuccess) {
        // Close dialog BEFORE showing notification to prevent flicker
        dispatch(closeResetMFADialog());
        dispatch(
          openNotificationThunk({
            variant: "info",
            text: `Sent a link to reset your multi-factor authentication to ${email ?? "your email"}.`,
          })
        );

        return true;
      }

      const errorMessage = "Failed to send MFA reset link.";

      dispatch(
        openNotificationThunk({
          variant: "warning",
          text: errorMessage,
        })
      );

      return rejectWithValue(errorMessage);
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message ?? "Failed to send MFA reset link.";

      dispatch(
        openNotificationThunk({
          variant: "warning",
          text: errorMessage,
        })
      );

      return rejectWithValue(errorMessage);
    }
  }
);
